import { ProjectDataService } from './../project-data.service';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ActivityCenterService } from 'app/shared/common/helper/activity-center';
import { ParseService } from 'app/shared/common/parse/parse.service';
import { QueryInterface } from 'app/shared/common/parse/query-interface';
import { StorageConfiguration } from 'app/shared/common/storage-setting/storage-configuration';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-create-project-info',
  templateUrl: './create-project-info.component.html',
  styleUrls: ['./create-project-info.component.scss']
})
export class CreateProjectInfoComponent implements OnInit {
  projectInfoForm: any;
  tenantId: any;
  clientList = [];
  projectStartMinDate = new Date();
  @Output() goNext = new EventEmitter<any>();
  projectId: any;
  constructor(
    private fb: FormBuilder,
    private queryInterface: QueryInterface,
    private storageConfiguration: StorageConfiguration,
    private parseService: ParseService,
    private activityCenterService: ActivityCenterService,
    private projectDataService: ProjectDataService,
    private route: ActivatedRoute

  ) { }

  ngOnInit(): void {
    this.tenantId = this.storageConfiguration.sessionGetItem(this.storageConfiguration.tenantId);
    this.getClient();
    this.createForm();
    this.route.params.subscribe((params) => {
      this.projectId = params['id'];
      if (this.projectId){
        const Project = this.parseService.instance.Object.extend('Project');
        const projectQuery = new this.parseService.instance.Query(Project);
        projectQuery.equalTo('objectId', this.projectId);
        projectQuery.find().then((projectResult) => {
          this.projectDataService.selectedBilling = projectResult[0].get('schedulerStatus');
          this.projectInfoForm.patchValue({
            projectName: projectResult[0].get('projectInfo').projectName,
            projectDescription: projectResult[0].get('projectInfo').projectDescription,
            clientName: projectResult[0].get('client').id
          });
        });
      }
    });

  }

  createForm(): void {
    this.projectInfoForm = this.fb.group({
      projectName: ['', Validators.required],
      // billingType: ['', Validators.required],
      projectDescription: [''],
      clientName: [''],
      projectStartDate: [],
      projectEndDate: []
    });
  }

  saveProjectInfo(): void {
    this.projectDataService.projectInformation = this.projectInfoForm.controls;
    this.goNext.emit({emit: true, form: this.projectInfoForm.controls});
  }


    /*
  ** ==========================================================
  ** Get Client Details
  ** ==========================================================
  */
  getClient(): void{
    let clientName = [];
    const result = [];
    this.queryInterface.executeQuery(this.parseService, 'Client', 
    [{ field: 'name', condition: 'descending' }, { condition: 'limit', value: 10000 }, { condition: 'equalTo', field: 'tenantId', value: this.tenantId },
    ]).then(results => {
      const jsonText = JSON.stringify(results);
      const clients = JSON.parse(jsonText);
      for (const client of clients) {
        clientName = client.companyInfo.firstName;
        this.clientList.push({
          id: client.objectId,
          name: clientName.concat(' ' + client.companyInfo.lastName)
        });
      }
    });
  }
}
